import { render, staticRenderFns } from "./TeacherClass.vue?vue&type=template&id=1c3d167a&scoped=true&"
import script from "./TeacherClass.vue?vue&type=script&lang=js&"
export * from "./TeacherClass.vue?vue&type=script&lang=js&"
import style0 from "./TeacherClass.vue?vue&type=style&index=0&id=1c3d167a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3d167a",
  null
  
)

export default component.exports